document.addEventListener('DOMContentLoaded', function () {
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');

  if (!productForms.length) return;

  productForms.forEach(function (form) {
    form.addEventListener('submit', async function (event) {
      const submitter = event.submitter;

      if (
        submitter &&
        submitter.name &&
        submitter.name === 'checkout'
      ) {
        return;
      }

      event.preventDefault();

      const accessoriesContainer = document.querySelector('[data-product-accessories]');
      const checkedAccessories = accessoriesContainer ? accessoriesContainer.querySelectorAll(
        'input[data-accessory-variant-id]:checked'
      ) : [];

      const formData = new FormData(form);

      if (!formData.get('id')) {
        console.error('Keine Hauptvariante gefunden.');
        return;
      }

      // Hauptprodukt als multipart/form-data senden, damit Datei-Uploads
      // (properties[...] vom Typ file) von Shopify hochgeladen werden.
      // Nur Variante, Menge und Line-Item-Properties übernehmen.
      const mainItemData = new FormData();
      formData.forEach((value, key) => {
        if (key === 'id' || key === 'quantity') {
          mainItemData.append(key, value);
          return;
        }

        if (!key.startsWith('properties[')) return;

        // Leere Datei-Felder (keine Datei gewählt) nicht mitsenden
        if (value instanceof File && !value.name && value.size === 0) return;

        mainItemData.append(key, value);
      });

      const accessoryItems = [];
      checkedAccessories.forEach(function (checkbox) {
        const accessoryVariantId = checkbox.getAttribute('data-accessory-variant-id');

        if (accessoryVariantId) {
          accessoryItems.push({
            id: parseInt(accessoryVariantId, 10),
            quantity: 1
          });
        }
      });

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: mainItemData
        });

        if (!response.ok) {
          throw new Error('Fehler beim Hinzufügen zum Warenkorb.');
        }

        if (accessoryItems.length > 0) {
          const accessoriesResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: accessoryItems })
          });

          if (!accessoriesResponse.ok) {
            throw new Error('Fehler beim Hinzufügen des Zubehörs zum Warenkorb.');
          }
        }

        showAddedMessage();

        const cartDrawerTrigger =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartDrawerTrigger && typeof cartDrawerTrigger.renderContents === 'function') {
          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();
          cartDrawerTrigger.renderContents(cartData);
        }
      } catch (error) {
        console.error(error);
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    });
  });

  function showAddedMessage() {
    const existingMessage = document.querySelector('[data-product-added-message]');
    if (existingMessage) {
      existingMessage.remove();
    }

    const toast = document.createElement('div');
    toast.setAttribute('data-product-added-message', '');
    toast.className = 'product-added-toast';
    toast.innerHTML = `
      <span class="product-added-toast__icon">✓</span>
      <span class="product-added-toast__text">Produkt wurde dem Warenkorb hinzugefügt</span>
    `;

    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('product-added-toast--visible');
    });

    setTimeout(function() {
      toast.classList.remove('product-added-toast--visible');
      setTimeout(function() {
        toast.remove();
      }, 300);
    }, 3000);
  }
});